import _ from "lodash";

const getAmount = _.property<{ price: { amount: number } }, number>(["price", "amount"]);

export const getPriceRange = (items: { price: { amount: number } }[]): { max: number | null; min: number | null } => {
    const allPrices: number[] = items.map(getAmount).filter(Number.isFinite);

    return {
        min: allPrices.length ? Math.max(0, Math.min(...allPrices)) : 0,
        max: allPrices.length ? Math.max(0, Math.max(...allPrices)) : 0,
    };
};
